import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'

import router from '../router'

import { ACTION_SUCCESS, ACTION_ERROR, TO_ROUTE } from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageTitle: null,
    menu: [
      { icon: 'assignment', iconClass: 'primary white--text', title: 'Procesos', subtitle: 'Listado', route: 'process-list' },
      { icon: 'assignment_late', iconClass: 'primary white--text', title: 'Incidencias', subtitle: 'Listado', route: 'incident-list' },
      { icon: 'insert_chart', iconClass: 'primary white--text', title: 'Informes', subtitle: 'Descargas', route: 'report-list' },
      { icon: 'event_note', iconClass: 'primary white--text', title: 'Pesadas', subtitle: 'Listado', route: 'measurement-list' },
      { icon: 'developer_board', iconClass: 'primary white--text', title: 'Dispositivos', subtitle: 'Listado', route: 'device-list' }
    ],
    notify: {
      timeout: 5000,
      message: null,
      mode: null,
      textColor: null,
      backgroundColor: null,
      visible: false,
      position: 'bottom'
    },
    session: {},
    socket: {
      isConnected: false,
      reconnectError: false,
      topics: {}
    },
    processTotalWeight: null
  },
  actions: {
    logIn ({ state }, data) {
      state.session = { token: data.token, profile: data.profile, modules: data.modules }
      localStorage.setItem(Vue.config.app.sessionName, JSON.stringify(state.session))
      router.push({ name: 'home' })
    },
    logOut ({ state }) {
      state.session = {
        token: null,
        profile: {},
        modules: {}
      }
      localStorage.removeItem(Vue.config.app.sessionName)
      router.push({ name: 'login' })
    },
    unsubscribe ({ state }, topic) {
      delete state.socket.topics[topic]
      Vue.prototype.$socket.sendObj({ topics: _.keys(state.socket.topics) })
    },
    subscribe ({ state }, subscription) {
      if (!subscription.topic) return

      state.socket.topics[subscription.topic] = {
        message: null,
        onMessage: subscription.onMessage
      }
      if (state.socket.isConnected) {
        Vue.prototype.$socket.sendObj({ topics: _.keys(state.socket.topics) })
      }
    },
    sendMessage: function (context, message) {
      Vue.prototype.$socket.send(message)
    }
  },
  getters: {
    authenticated (state) {
      return state.session && state.session.token
    },
    profile (state) {
      return state.session.profile || {}
    },
    token (state) {
      return state.session.token || null
    },
    navigation (state) {
      return _.filter(state.menu, (x) => _.includes(state.session.modules, x.title))
    }
  },
  mutations: {
    initialiseStore (state) {
      const sessionName = Vue.config.app.sessionName
      if (localStorage.getItem(sessionName)) {
        Object.assign(state.session, JSON.parse(localStorage.getItem(sessionName)))
      }
    },
    [ACTION_SUCCESS] (state, message) {
      Object.assign(state.notify, {
        message: message,
        backgroundColor: null,
        textColor: 'success',
        visible: true
      })
    },
    [ACTION_ERROR] (state, message) {
      Object.assign(state.notify, {
        message: message,
        backgroundColor: 'error',
        textColor: null,
        visible: true,
        position: 'top'
      })
    },
    [TO_ROUTE] (state, name) {
      if (name === 'logout') {
        this.logout()
      } else {
        router.push({ name: name })
      }
    },
    SOCKET_ONOPEN (state, event) {
      Vue.prototype.$socket = event.currentTarget
      Vue.prototype.$socket.sendObj({ topics: _.keys(state.socket.topics) })
      state.socket.isConnected = true
    },
    SOCKET_ONCLOSE (state, event) {
      state.socket.isConnected = false
    },
    SOCKET_ONERROR (state, event) {
      console.error(state.socket, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, message) {
      _.each(state.socket.topics, (subscription) => {
        subscription.message = message
        subscription.onMessage(message)
      })
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT (state, count) {
      console.info('reconnect')
    },
    SOCKET_RECONNECT_ERROR (state) {
      state.socket.reconnectError = true
    },
    setProcessTotalWeight (state, total) {
      state.processTotalWeight = parseFloat(total)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js